import React from 'react'

const EmploymentIcon = () => {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_851_3804" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="33">
                <rect x="0.0717773" y="0.496185" width="32" height="32" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_851_3804)">
                <path d="M5.40519 28.4962C4.67186 28.4962 4.04408 28.2351 3.52186 27.7129C2.99964 27.1906 2.73853 26.5629 2.73853 25.8295V20.4962H12.0719V23.1629H20.0719V20.4962H29.4052V25.8295C29.4052 26.5629 29.1441 27.1906 28.6219 27.7129C28.0996 28.2351 27.4719 28.4962 26.7385 28.4962H5.40519ZM14.7385 20.4962V17.8295H17.4052V20.4962H14.7385ZM2.73853 17.8295V11.1629C2.73853 10.4295 2.99964 9.80174 3.52186 9.27952C4.04408 8.7573 4.67186 8.49619 5.40519 8.49619H10.7385V5.82952C10.7385 5.09619 10.9996 4.46841 11.5219 3.94619C12.0441 3.42396 12.6719 3.16285 13.4052 3.16285H18.7385C19.4719 3.16285 20.0996 3.42396 20.6219 3.94619C21.1441 4.46841 21.4052 5.09619 21.4052 5.82952V8.49619H26.7385C27.4719 8.49619 28.0996 8.7573 28.6219 9.27952C29.1441 9.80174 29.4052 10.4295 29.4052 11.1629V17.8295H20.0719V15.1629H12.0719V17.8295H2.73853ZM13.4052 8.49619H18.7385V5.82952H13.4052V8.49619Z" fill="#1A1A1A" />
            </g>
        </svg>

    )
}

export default EmploymentIcon